import styled from "@emotion/styled";
import { FC } from "react";

import { Avatar, DesignToken, PickerType, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { ITeam } from "store/entities/teams";
import { textEllipsisStyles } from "styles/common";
import { withVar } from "themes/helpers";

interface IProps {
  name: string;
  pickerType: PickerType;
  isDefault?: boolean;
  secondaryText?: string;
  avatarOnly?: boolean;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const mapTeamsToPickerItems = (teams: ITeam[]) =>
  teams.map(({ id, name, isDefault }) => ({
    key: id,
    name,
    customElement: {
      listItemBody: <TeamPickerListItem name={name} pickerType="multi" isDefault={isDefault} />,
      selectedItemBody: <TeamPickerSelectedListItem name={name} pickerType="multi" isDefault={isDefault} />,
    },
  }));

export const TeamPickerListItem: FC<IProps> = ({ name, isDefault, secondaryText, avatarOnly }) => (
  <Flex alignItems="center" gap={withVar(SpacingToken.Spacing2)} data-testid={`list-item-${name}`}>
    <Avatar size={secondaryText ? "small" : "xxsmall"} type="text" text={name} shape="rounded-square" />
    {!avatarOnly && (
      <Content>
        <Text bold={!!secondaryText} css={textEllipsisStyles}>
          {name}
          {isDefault && <span css={{ color: withVar(DesignToken.ContentBasicSecondary) }}> (Default team)</span>}
        </Text>
        {secondaryText && (
          <Text size="xs" css={[{ color: withVar(DesignToken.ContentBasicSecondary) }, textEllipsisStyles]}>
            {secondaryText}
          </Text>
        )}
      </Content>
    )}
  </Flex>
);

const Content = styled.div<{ isSecondaryText?: boolean }>`
  display: flex;
  flex-direction: column;
  width: calc(
    100% - var(
        ${
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
          ({ isSecondaryText }: any) => (isSecondaryText ? SpacingToken.Spacing10 : SpacingToken.Spacing7)
        }
      )
  );
`;

export const TeamPickerSelectedListItem: FC<IProps> = ({ name, isDefault, secondaryText, pickerType, avatarOnly }) => {
  return (
    <Flex
      alignItems="center"
      gap={withVar(pickerType === "single" ? SpacingToken.Spacing2 : SpacingToken.Spacing1)}
      maxWidth="100%"
    >
      <Avatar size={pickerType === "single" ? "xxsmall" : "xxxsmall"} type="text" text={name} shape="rounded-square" />
      {!avatarOnly && (
        <>
          <Text css={textEllipsisStyles}>
            {name}
            {isDefault && <span css={{ color: withVar(DesignToken.ContentBasicSecondary) }}> (Default team)</span>}
          </Text>
          {secondaryText && (
            <Text size="xs" css={[{ color: withVar(DesignToken.ContentBasicSecondary) }, textEllipsisStyles]}>
              {secondaryText}
            </Text>
          )}
        </>
      )}
    </Flex>
  );
};
